import WorkflowModal from './WorkflowModal';
import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { apiClient, showToast } from '../../utils/apiClient';
import { API } from '../../config';
import { formatDate, formatDateTime, formatNotesWithBullets, getDayOfWeek, formatDateWithDay, getLocationDisplay, getLocationChipColor, getRowAlert, formatDatetimeForInput, parseUTCDatetime, getTodayInAEST, isPrepaymentApproaching, hasAppointments, getAppointmentSummary } from '../../utils/helpers';


const WorkflowQuickUpdate = ({ pet, onUpdate, openSMSModal, openEmailModal, openCertificateModal }) => {
  const [showModal, setShowModal] = useState(false);

  const handleSuccess = () => {
    setShowModal(false);
    onUpdate();
    showToast('Workflow updated successfully! Status auto-updated. ✅');
  };

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        data-testid="open-workflow-button"
        className="text-sm bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-md transition-colors"
      >
        Quick Update Workflow
      </button>
      
      {showModal && (
        <WorkflowModal
          pet={pet}
          onClose={() => setShowModal(false)}
          onSuccess={handleSuccess}
          openSMSModal={openSMSModal}
          openEmailModal={openEmailModal}
          openCertificateModal={openCertificateModal}
        />
      )}
    </>
  );
};


export default WorkflowQuickUpdate;
